




import {Vue, Component} from 'vue-property-decorator'

import Account  from '@/components/Account.vue'

@Component({
  components: {
      Account
  }
})
export default class AccountView extends Vue {
}
